import styles from './styles.module.scss';
import { CheckmarkIcon } from '../../../../../../../../../../ui/icons/CheckmarkIcon';
import { Typography } from 'antd';
import { ChapterState } from '../../../../../../../../../../lib/models/TemplateTypes';
import { getDisplayedProduct } from '../../../ProductBasedPreviewLayoutTemplates/PreviewChapterLayout/FirstChapter/utils';
import { useLocalization } from '../../../../../../../../../../lib/hooks/useLocalization';
import { AppText } from '../../../../../../../../../../ui/text/AppText';
import { CircleIconNew } from '../../../../../../../../../../ui/icons/CircleIconNew';
import { TwoIcon } from '../../../../../../../../../../ui/icons/TwoIcon';
import { ThreeIcon } from '../../../../../../../../../../ui/icons/ThreeIcon';
import { FourIcon } from '../../../../../../../../../../ui/icons/FourIcon';
import { OneIcon } from '../../../../../../../../../../ui/icons/OneIcon';

// eslint-disable-next-line max-lines-per-function
export function Card({ chapter, chapterIndex, chapterIconMedia, currentChapterId, colors, recommendedProductIds = [], fonts }) {
  const { badge } = useLocalization().translations.unique.components.productBasedFinder.sidebar;

  const { content, content: { headline, selectChapterIcon } = {}, state, id: chapterId, resultSelectedProducts } = chapter;

  const chapterNumber = chapterIndex + 1;

  const chapterIcon = chapterIconMedia.find(el => el.id === selectChapterIcon?.value);

  const displayedProduct = getDisplayedProduct(resultSelectedProducts, content?.productsPriority);

  const isCompletedChapter = state === ChapterState.COMPLETED || displayedProduct;

  const isRecommendation = resultSelectedProducts?.some(el => {
    // if (el?.id !== displayedProduct?.id) return null;
    const productId = el?.productNameSection?.product?.value;
    return recommendedProductIds.includes(productId);
  });

  const getChapterIndexIcon = () => {
    if (chapterIndex === 0) {
      return <OneIcon width={17} height={41} />;
    }

    if (chapterIndex === 1) {
      return <TwoIcon width={17} height={41} />;
    }
    // eslint-disable-next-line no-magic-numbers
    if (chapterIndex === 2) {
      return <ThreeIcon width={17} height={41} />;
    }
    // eslint-disable-next-line no-magic-numbers
    if (chapterIndex === 3) {
      return <FourIcon width={17} height={41} />;
    }
    return null;
  };

  if (isCompletedChapter) {
    return (
      <div
        className={styles.card}
        style={{
          backgroundColor: colors?.backgroundColorSecond,
          border: state === ChapterState.OPENED && currentChapterId === chapterId ? '3px solid rgba(255, 102, 0, 1)' : '3px solid transparent',
        }}
      >
        <div className={styles.cardContent}>
          {isRecommendation && (
            <AppText
              textValue={badge}
              className={styles.badge}
              style={{
                backgroundColor: colors?.primaryColor,
                fontFamily: fonts.body.font,
              }}
            />
          )}

          <div
            className={styles.title}
            style={{
              fontFamily: fonts.body.font,
            }}
          >
            {headline?.value}
          </div>

          {resultSelectedProducts?.map(product => {
            return (
              <div className={styles.product} key={product.id}>
                <div className={styles.product_check}>
                  <CheckmarkIcon width={7} height={5} fill='#fff' />
                </div>

                <Typography.Title
                  level={3}
                  ellipsis={{ rows: 2 }}
                  style={{
                    marginBottom: 0,
                    fontSize: 12,
                    lineHeight: 1.2,
                    color: 'rgba(0, 0, 0, 0.62)',
                    fontFamily: fonts.body.font,
                  }}
                >
                  {product?.productNameSection?.product?.title}
                </Typography.Title>
              </div>
            );
          })}
        </div>

        <div className={styles.right}>
          <div className={styles.chapter}>
            {displayedProduct ? (
              chapterIcon?.s3Url && <img src={chapterIcon?.s3Url} alt='Product1' />
            ) : (
              <div className={styles.circleWrapper}>
                <span>{getChapterIndexIcon()}</span>
                <CircleIconNew width={50} height={50} />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={styles.card}
      style={{
        backgroundColor: colors?.backgroundColorSecond,
        border: state === ChapterState.OPENED && currentChapterId === chapterId ? '3px solid rgba(255, 102, 0, 1)' : '3px solid transparent',
      }}
    >
      <div className={styles.left}>
        <span className={styles.badgeChapterIndex} style={{ fontFamily: fonts.body.font }}>
          {chapterNumber}
        </span>
        <div
          className={styles.title}
          style={{
            fontFamily: fonts.body.font,
          }}
        >
          {headline?.value}
        </div>
      </div>

      <div className={styles.right}>
        <div className={styles.chapter}>
          {/* <div className={styles.circle}>{chapterNumber}</div> */}
          <div className={styles.circleWrapper}>
            <span>{getChapterIndexIcon()}</span>
            <CircleIconNew width={50} height={50} />
          </div>
        </div>
      </div>
    </div>
  );
}
